import { render } from "./PermitDashboard.vue?vue&type=template&id=20ade488"
import script from "./PermitDashboard.vue?vue&type=script&lang=ts"
export * from "./PermitDashboard.vue?vue&type=script&lang=ts"
script.render = render

export default script